<script>
import moment from 'moment'

const mapIntervalStringToUnit = {
    '1m': 'minute',
    '1h': 'hour',
    '1d': 'day',
    '1M': 'month',
    '1y': 'year'
}

const mapIntervalStringToLabel = {
    '1m': 'YYYY-MM-DD HH:mm',
    '1h': 'YYYY-MM-DD HH',
    '1d': 'YYYY-MM-DD',
    '1M': 'YYYY-MM',
    '1y': 'YYYY'
}

export default {
    name: 'ChartMixin',
    props: {
        data: Array,
        timeRange: Object,
        interval: String
    },
    data () {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{ stacked: true }],
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            callback: value => value % 1 === 0 ? value : ''
                        }
                    }]
                },
                animation: false
            },
            labelList: [],
            displayLabelList: [],
            mapLabelToIndex: {}
        }
    },
    mounted () {
        this.updateChart()
    },
    methods: {
        generateLabels () {
            let labelList = []
            let displayLabelList = []
            let timeUnit = mapIntervalStringToUnit[this.interval]
            let time = moment(this.timeRange.to).startOf(timeUnit)
            let from = moment(this.timeRange.from).endOf(timeUnit)
            while (time.diff(from, timeUnit) >= 0) {
                labelList.push(time.format('YYYY-MM-DDTHH:mm:ss.SSSZ'))
                displayLabelList.push(time.format(mapIntervalStringToLabel[this.interval]))
                time = time.subtract(1, timeUnit)
            }
            labelList = labelList.reverse()
            displayLabelList = displayLabelList.reverse()
            let mapLabelToIndex = {}
            for (let i in labelList) {
                mapLabelToIndex[labelList[i]] = i
            }
            this.labelList = labelList
            this.displayLabelList = displayLabelList
            this.mapLabelToIndex = mapLabelToIndex
        },
        updateChart () {
        }
    },
    watch: {
        data: 'updateChart',
        timeRange: 'updateChart',
        interval: 'updateChart'
    }
}
</script>
